import React from 'react';
import {
    reduxForm,
} from 'redux-form';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';

import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { AuthAPI } from "../../API";
import { changePasswordDict } from 'Languages/ContactsTranslations';
import { checkStrongPassword } from "../../Helper/Validations";

export type FormValue = {
    "name": string,
};

type State = {
    status: string,
    error: string | null,
    country: any,
    name: string,
};

class ChangePasswordForm extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            currentPassword: '',
            newPassword: "",
            confirmPassword: '',
            isPasswordMatched: false,
            isValidPassword: true,
            notValidPasswordText: "",
            isValidConfirmPassword: true,
            notValidConfirmPasswordText: "",
            isConfirmPasswordVisible: false,
            isNewPasswordVisible: false,
            isCurrentPasswordVisible: false,

        };
    }

    formValues() {
        return {
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            userId: this.props.id,
        };
    }

    onSubmit() {
        if (this.props.id) {
            return this.ChangePassword();
        }
    }

    ChangePassword() {
        const valuesIn = this.formValues()
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Submitting }))
            .then(() => AuthAPI.ChangePassword(valuesIn))
            .then((country) => {
                this.props.onSubmit();
                alert(this.props.language === 'hi' ? 'पासवर्ड सफलतापूर्वक बदला गया' : 'Password Changed Successfully.');
                return this.setState({ status: PageStatus.Submitted });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: (this.props.language === 'hi' ? 'पुराना पासवर्ड गलत है।' : error.message) });
            });
    }

    isPasswordStrong(ele, type) {
        if (ele.target.value === "") {
            const updatedState = {
                [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: true,
                [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: "",
                isButtonDisabled: false
            };
            this.setState(updatedState);
            return;
        }
        let passwordChecks = checkStrongPassword(ele);
        let isHindiTrue = this.props.language === 'hi';
        const getLabel = () => {
            if (type === 'password') { return isHindiTrue ? "पासवर्ड" : "Password"; }
            return isHindiTrue ? "कन्फर्म पासवर्ड" : "Confirm password";
        };
        const errorMessages = [
            {
                condition: passwordChecks.capitalLatterCheck,
                message: isHindiTrue ? " में एक बड़ा अक्षर होना चाहिए" : " should contain one capital letter"
            },
            {
                condition: passwordChecks.smallLatterCheck,
                message: isHindiTrue ? " में एक छोटा अक्षर होना चाहिए" : " should contain one small letter"
            },
            {
                condition: passwordChecks.numericValCheck,
                message: isHindiTrue ? " में एक संख्यात्मक मान होना चाहिए" : " should contain one numeric value"
            },
            {
                condition: passwordChecks.specialCharCheck,
                message: isHindiTrue ? " में एक विशेष प्रतीक होना चाहिए" : " should contain one special character"
            },
            {
                condition: passwordChecks.lengthCheck,
                message: isHindiTrue ? " की लंबाई कम से कम 8 अक्षर की होनी चाहिए" : " length should be atleast of 8 character"
            },
        ];
        const firstFailed = errorMessages.find(error => !error.condition);
        const isAllValid = errorMessages.every(error => error.condition);
        const label = getLabel();
        const stateUpdate = {
            [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: isAllValid,
            [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: isAllValid ? "" : label + firstFailed.message,
            isButtonDisabled: !isAllValid
        };
        this.setState(stateUpdate);
    }

    onChangePassword(value, type) {
        let { newPassword, confirmPassword } = this.state;
        if (type === 'confirmPassword') {
            confirmPassword = value;
        } else {
            newPassword = value;
        }
        if (newPassword !== '' && confirmPassword !== '' && newPassword === confirmPassword) {
            this.setState({
                isPasswordMatched: true
            })
        } else {
            this.setState({
                isPasswordMatched: false
            })
        }
    }

    render() {
        const conditionalVarObj = {
            true: {
                "inputPswIcon": "fa fa-eye-slash",
                "inputPwType": "text",
                "respoMsg": "18px",
            },
            false: {
                "inputPswIcon": "fa fa-eye",
                "inputPwType": "password",
                "respoMsg": "16px",
            },
        };
        const lang = this.props.language ?? 'en';
        return (
            <Modal
                centered
                size="lg"
                backdrop="static"
                onHide={this.props.onClose}
                show={this.props.show}
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {changePasswordDict[lang]["Change Password"] || "Change Password"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <form onSubmit={this.props.handleSubmit(() => this.onSubmit())}>
                        <div className="form-group">

                            <label htmlFor="titleEng">
                                {changePasswordDict[lang]["Current Password"] || "Current Password"}*
                            </label>
                            <div className="password-container" style={{ position: 'relative', }}>
                                <button
                                    type="button"
                                    style={{ position: 'absolute', top: '70%', backgroundColor: "white", right: '10px', transform: 'translateY(30%)' }}
                                    onClick={() => this.setState((prev) => ({ isCurrentPasswordVisible: !prev.isCurrentPasswordVisible }))}
                                    className={this.state.currentPassword.length > 0 ? "bg-transparent" : "d-none"}
                                >
                                    <i className={conditionalVarObj[!this.state.isCurrentPasswordVisible]["inputPswIcon"]}></i>
                                </button>
                            </div>
                            <input
                                // type='password'
                                type={conditionalVarObj[this.state.isCurrentPasswordVisible]["inputPwType"]}
                                className="form-control"
                                onChange={(e) => this.setState({ currentPassword: e.target.value, error: null })}
                                value={this.state.currentPassword}
                                placeholder={changePasswordDict[lang]["Enter..."] || "Enter..."}
                                required
                            />


                            <label htmlFor="titleEng">
                                {changePasswordDict[lang]["New Password"] || "New Password"}*
                            </label>
                            <div className="password-container" style={{ position: 'relative', }}>
                                <input
                                    className="form-control"
                                    type={conditionalVarObj[this.state.isNewPasswordVisible]["inputPwType"]}
                                    onChange={(e) => {
                                        this.onChangePassword(e.target.value, 'newPassword');
                                        this.setState({ newPassword: e.target.value });
                                    }}
                                    onInput={(e) => this.isPasswordStrong(e, 'password')}
                                    value={this.state.newPassword}
                                    placeholder={changePasswordDict[lang]["Enter..."] || "Enter..."}
                                    required
                                />
                                <button
                                    type="button"
                                    style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                                    onClick={() => this.setState((prev) => ({ isNewPasswordVisible: !prev.isNewPasswordVisible }))}
                                    className={this.state.newPassword.length > 0 ? "bg-transparent" : "d-none"}
                                >
                                    <i className={conditionalVarObj[!this.state.isNewPasswordVisible]["inputPswIcon"]}></i>
                                </button>
                            </div>
                            {!this.state.isValidPassword ? <div className="text-danger mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>{this.state.notValidPasswordText}</div> : ""}

                            <label htmlFor="titleEng">
                                {changePasswordDict[lang]["Confirm New Password"] || "Confirm New Password"}*
                            </label>
                            <div className="password-container" style={{ position: 'relative', }}>
                                <input
                                    type={conditionalVarObj[this.state.isConfirmPasswordVisible]["inputPwType"]}
                                    className="form-control"
                                    onChange={(e) => {
                                        this.onChangePassword(e.target.value, 'confirmPassword');
                                        this.setState({ confirmPassword: e.target.value });
                                    }}
                                    onInput={(e) => this.isPasswordStrong(e, 'confirmpassword')}
                                    value={this.state.confirmPassword}
                                    placeholder={changePasswordDict[lang]["Enter..."] || "Enter..."}
                                    required
                                />
                                <button
                                    type="button"
                                    style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                                    onClick={() => this.setState((prev) => ({ isConfirmPasswordVisible: !prev.isConfirmPasswordVisible }))}
                                    className={this.state.confirmPassword.length > 0 ? "bg-transparent" : "d-none"}
                                >
                                    <i className={conditionalVarObj[!this.state.isConfirmPasswordVisible]["inputPswIcon"]}></i>
                                </button>
                            </div>
                            {!this.state.isValidConfirmPassword ? <div className="text-danger mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} >{this.state.notValidConfirmPasswordText}</div> : ""}
                        </div>

                        {this.state.isPasswordMatched === true && this.state.isValidPassword && this.state.isValidConfirmPassword && !this.state.error ?
                            <div className="alert alert-success">{changePasswordDict[lang]["Passwords Matched"] || "Passwords matched!"}</div> : ""
                        }
                        {this.state.isPasswordMatched !== true && this.state.newPassword && this.state.confirmPassword && this.state.isValidPassword && this.state.isValidConfirmPassword ?
                            <div className="alert alert-danger">{changePasswordDict[lang]["Not Matched"] || "Not Matched"}</div> : ""
                        }
                        <hr />
                        <Alert variant="danger" show={!!this.state.error} className="mt-2">
                            {this.state.error}
                        </Alert>

                        <div className="d-flex align-items-center mt-2">
                            <button
                                type="submit"
                                disabled={!this.state.newPassword || !this.state.currentPassword || this.state.newPassword !== this.state.confirmPassword || !this.state.isValidPassword || !this.state.isValidConfirmPassword}
                                className="btn btn-primary mr-3"
                            >
                                {changePasswordDict[lang]["Change"] || "Change"}
                            </button>
                            <Show when={this.state.status === PageStatus.Submitting}>
                                <Spinner animation="border" variant="primary" />
                            </Show>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }
}

const ChangePasswordFormRedux = reduxForm<FormValue, any>({
    form: 'labelsChangePasswordForm',
})(ChangePasswordForm);


const ChangePasswordFormWithRouter = withRouter(ChangePasswordFormRedux);

export { ChangePasswordFormWithRouter as ChangePasswordForm };
